


import DeleteIcon from '@mui/icons-material/Delete';
import { IoArrowBack } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const SubmittedComplaint = () => {
  const navigate = useNavigate();
  const [hoveredRow, setHoveredRow] = useState(null);
  const [complaints, setComplaints] = useState([]);

  const fetchComplaints = async (brandId) => {
    try {
      const complaintsRes = await fetch(`https://server-side-influencer.onrender.com/brand/mycomplaints/${brandId}`);
      const complaintsData = await complaintsRes.json();
      if (complaintsData.success) {
        setComplaints(complaintsData.data);
      }
    } catch (err) {
      console.error("Failed to fetch complaints:", err);
      toast.error("Failed to fetch complaints");
    }
  };

  useEffect(() => {
    const fetchBrandData = async () => {
      const brandId = localStorage.getItem("brandID");
      await fetchComplaints(brandId);
    };
    fetchBrandData();
  }, []);

  const handleDelete = async (id) => {
    try {
      await fetch(`https://server-side-influencer.onrender.com/brand/deletemycomplaint/${id}`, {
        method: 'DELETE',
      });

      const brandId = localStorage.getItem("brandID");
      if (brandId) {
        await fetchComplaints(brandId);
      }

      toast.success("Complaint deleted successfully!");
    } catch (err) {
      console.error("Error deleting complaint:", err);
      toast.error("Failed to delete complaint");
    }
  };

  return (
    <div>
      <div className="bg-gray-100 text-black flex items-center justify-between p-4 fixed w-full top-0 left-0 z-50 shadow-md">
        <div onClick={() => navigate(-1)} className="cursor-pointer flex items-center">
          <IoArrowBack size={24} />
          <span className="ml-2">Back</span>
        </div>
        <div className="text-right font-semibold text-lg">Complaints</div>
      </div>

      <div className="pt-24 px-6">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4 text-center">Brand Submitted Complaint</h2>
        <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
          {complaints.length === 0 ? (
            <div className="text-center text-gray-600 py-10 text-lg font-medium">
              No complaint registered yet.
            </div>
          ) : (
            <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" className="px-6 py-3">Brand Name</th>
                  <th scope="col" className="px-6 py-3">Email</th>
                  <th scope="col" className="px-6 py-3">Subject</th>
                  <th scope="col" className="px-6 py-3">Message</th>
                  <th scope="col" className="px-6 py-3">Date</th>
                </tr>
              </thead>
              <tbody>
                {complaints.map((complaint, index) => (
                  <tr
                    key={index}
                    className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700"
                    onMouseEnter={() => setHoveredRow(index)}
                    onMouseLeave={() => setHoveredRow(null)}
                  >
                    <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white flex items-center gap-2">
                      {complaint.brandName}
                      {hoveredRow === index && (
                        <button
                          onClick={() => handleDelete(complaint._id)}
                          className="text-red-500 hover:text-red-700"
                          title="Delete Complaint"
                        >
                          <DeleteIcon fontSize="small" />
                        </button>
                      )}
                    </td>
                    <td className="px-6 py-4">{complaint.email}</td>
                    <td className="px-6 py-4">{complaint.subject}</td>
                    <td className="px-6 py-4">{complaint.message}</td>
                    <td className="px-6 py-4">
                      {new Date(complaint.createdAt).toLocaleDateString('en-GB')}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>

      <ToastContainer
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

export default SubmittedComplaint;
